import { Page, PageHeader } from 'components';
import VitecUsersProvider from './VitecUsersContext';
import { Results, Filters } from './components';


let VitecUsers = () => {
    return (
        <Page>
            <VitecUsersProvider>
                <PageHeader
                    pageTitle="Videndum users"
                    addNewUrl="/admin/videndumuser/addnew"
                />
                <Filters />
                <Results />
            </VitecUsersProvider>
        </Page>
    )
}

export default VitecUsers;